// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__r2a3e"};